﻿﻿﻿<div class="container-tab-lists">
    <!--<changelog-menu (controllerChanged)="onControllerChanged($event)"></changelog-menu>-->
    <changelog-list [list]="list"></changelog-list>
</div> <!-- container-tab-lists -->
